import React from 'react'

import Webinar from 'lemon-campaign-ui/lib/molecules/Webinar'
import linking from '../../helper/linking'
import { getVisible } from '../../globals/visible-components'

export default ({ component, defaults, handlers }) => {

  const visible = getVisible(component._id)
  if (!visible) {
    return null
  }

  return (
    <Webinar
      {...defaults}

      hasResponsiveContainer={component.content.responsive.hasContainer}
      responsiveOptions={component.content.responsive.options}

      videoUrl={component.content.video}
      durationTrigger={component.content.duration}
      messageText={component.content.placeholderText}
      buttonText={component.content.text}
      buttonColor={component.content.backgroundColor}
      buttonTextColor={component.content.color}

      buttonLink={linking(component)}

      clickHandler={(val, extraState) => handlers.button(val, extraState,
        component)}
    />
  )
}
